<template>
	<div id="app">
		<!-- Cf fichier route.ts -->
		<!-- Embarque l'application entière -->
		<keep-alive v-if="$store.getters['IsLoggedIn']">
			<router-view :key="$route.fullPath"></router-view>
		</keep-alive>

		<!-- Embarque la ConnexionPage -->
		<router-view v-else :key="$route.fullPath"></router-view>

		<b-overlay no-wrap fixed :show="showLoadingMask" :opacity="0.3" z-index="5000">
			<template #overlay>
				<b-img height="150rem" width="150rem" center :src="AbsoluteLink('Images/Dcx_Loading.png')" />
				<h6 class="text-primary">{{ loadingMaskMessage }}</h6>
			</template>
		</b-overlay>
	</div>
</template>

<script lang="ts">
	import { Component, Vue } from 'vue-property-decorator';
	import VueCookies from 'vue-cookies-ts';
	import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
	import Vuex from 'vuex';
	import { Getter } from 'vuex-class';
	import { createStore } from 'vuex-extensions';
	import { mixins } from 'vue-class-component';
	import PortalVue from 'portal-vue';
	import loadingMaskPlugIn from '@/components/plugins/loadingMask/plugin';
	import axiosDirectPlugIn from '@/components/plugins/axiosGlobal/plugin';
	import axios from 'axios';
	import VueRouter from 'vue-router';
	import VueFormWizard from 'vue-form-wizard';
	import 'vue-form-wizard/dist/vue-form-wizard.min.css'

	//#region Pages de l'application DCX
	import ConnexionPage from './components/ConnexionPage.vue';
	import SignPage from './components/SignPage.vue';
	import MasterPage from './components/MasterPage.vue';
	import SupervisionPage from './components/SupervisionPage.vue';
	//#endregion Pages de l'application DCX
	
	import LoadingMask from './components/commons/control-loadingmask.vue';
	import 'bootstrap-vue/dist/bootstrap-vue.css';
	import { routes } from './router/route';
	import moment from 'moment';
	import 'moment/min/locales';

	import { library } from "@fortawesome/fontawesome-svg-core";
	import { faClock, faHourglass, faSquare as faSquareReg, faCircle as faCircleReg, faCircleCheck as faCircleCheckReg } from "@fortawesome/free-regular-svg-icons";
	import { faObjectGroup, faUserFriends, faUserEdit, faBrush, faBook, faGlobeEurope, faUpload, faServer, faNewspaper, faWindowRestore, faBookReader, faTemperatureHigh, faTemperatureLow, faTag, faAddressBook, faIdBadge, faUser, faTruck, faFileContract, faMapMarker, faUserNinja, faCompressArrowsAlt, faExpandArrowsAlt, faDownload, faChartPie, faCopy, faAward, faChartLine, faChartBar, faChevronCircleUp, faChevronCircleDown, faHistory, faCog, faPlay, faPause, faCubes, faMap, faBolt, faWater, faBurn, faGasPump, faPlus, faMinus, faEdit, faUndo, faSitemap, faDirections, faColumns, faAtom, faTint, faReceipt, faInfoCircle, faCity, faBookOpen, faDoorOpen, faClipboard, faLock, faCircle, faSave, faSync, faWindowClose, faArrowsAlt, faWindowMaximize, faSignOutAlt, faArrowCircleRight, faChalkboard, faCoffee, faFilter, faTrash, faTimes, faMinusSquare, faPlusSquare, faSquare, faFolderOpen, faEye, faStar, faBookmark, faCheckSquare, faTags, faArrowAltCircleUp, faTachometerAlt, faShoePrints, faTable, faClipboardCheck, faCheck, faSort, faSortUp, faSortDown, faX, faXmark, faPen, faPaste, faClockRotateLeft, faFolderTree, faBars, faMapLocationDot, faLocationDot, faCheckDouble, faListCheck, faSquareXmark, faCircleCheck, faExpand, faChartSimple, faChartColumn, faRightFromBracket, faCalendarPlus, faThumbsDown, faThumbsUp, faBackwardStep, faForwardStep, faBuilding, faDatabase, faStethoscope, faLeaf, faFileLines, faICursor, faTableCells, faTableCellsLarge, faSheetPlastic, faFireFlameSimple, faGear, faArrowDown, faArrowUp, faArrowUp19, faFilePen, faImage, faImages, faListOl, faIdCard, faMagnifyingGlass, faArrowsRotate, faGears, faCalendar, faCircleArrowLeft, faCalendarDays, faArrowRightFromBracket, faUsers, faUserTie, faUserPen, faBasketShopping, faAddressCard, faPersonChalkboard, faEarthEurope, faFileImport, faScrewdriverWrench, faBezierCurve, faCloudSunRain, faFile, faDesktop, faMobileRetro, faRulerCombined, faChalkboardUser, faQuestion, faTreeCity, faPlugCircleBolt, faLightbulb, faSeedling, faFire, faMaskVentilator, faFileInvoiceDollar, faLandmark, faCubesStacked, faPlug, faBuildingColumns, faDiagramNext, faRulerVertical, faSliders, faBorderNone, faGripVertical, faTriangleExclamation, faCheckCircle, faCalendarTimes, faAnglesUp, faBan, faIdCardClip,faCircleInfo, faGreaterThan, faGreaterThanEqual, faLessThan, faLessThanEqual, faEquals, faGauge, faBoltLightning, faSolarPanel, faCarBattery, faChargingStation, faFaucet, faShower, faDroplet, faDropletSlash, faLadderWater, faSterlingSign, faCoins, faWallet, faDollar, faCentSign, faEuroSign, faGlobe, faSpellCheck, faGaugeSimple, faGaugeSimpleHigh, faGaugeMed, faGaugeHigh, faFileCsv, faFilePdf, faEnvelope, faFileExcel, faFileWord, faFileImage, faList, faCloudSun, faWind, faBatteryQuarter, faSmog, faTemperatureQuarter, faA, faSlash, faExclamationTriangle, faLaptopCode, faFileSignature, faBurst, faBoxArchive,faEnvelopeOpenText, faEraser, faFileCirclePlus, faRss, faThumbTack, faCloudArrowUp, faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons";
	import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
    library.add({ faObjectGroup, faUserFriends, faUserEdit, faBrush, faBook, faGlobeEurope, faUpload, faServer, faNewspaper, faWindowRestore, faBookReader, faTemperatureHigh, faTemperatureLow, faTag, faAddressBook, faIdBadge, faUser, faTruck, faArrowAltCircleUp, faFileContract, faMapMarker, faUserNinja, faCompressArrowsAlt, faExpandArrowsAlt, faDownload, faChartPie, faClock, faTachometerAlt, faCopy, faShoePrints, faHourglass, faAward, faChartLine, faTable, faChartBar, faChevronCircleUp, faChevronCircleDown, faHistory, faSquareReg, faCog, faPlay, faPause, faCubes, faMap, faBolt, faWater, faBurn, faGasPump, faPlus, faMinus, faEdit, faUndo, faFilter, faSitemap, faDirections, faColumns, faClipboardCheck, faCheck, faAtom, faTint, faReceipt, faInfoCircle, faCity, faBookOpen, faDoorOpen, faClipboard, faLock, faCircle, faSave, faSync, faWindowClose, faArrowsAlt, faWindowMaximize, faSignOutAlt, faArrowCircleRight, faChalkboard, faCoffee, faTrash, faTimes, faMinusSquare, faPlusSquare, faSquare, faFolderOpen, faEye, faStar, faBookmark, faCheckSquare, faTags, faSort, faSortUp, faSortDown, faX, faXmark, faPen, faPaste, faClockRotateLeft, faFolderTree, faBars, faMapLocationDot, faLocationDot, faCheckDouble, faListCheck, faSquareXmark, faCircleCheck, faExpand, faChartSimple, faChartColumn, faRightFromBracket, faCalendarPlus, faThumbsDown, faThumbsUp, faBackwardStep, faForwardStep, faBuilding, faDatabase, faStethoscope, faLeaf, faFileLines, faICursor, faTableCells, faTableCellsLarge, faSheetPlastic, faFireFlameSimple, faGear, faArrowDown, faArrowUp, faArrowUp19, faFilePen, faImage, faImages, faListOl, faIdCard, faMagnifyingGlass, faArrowsRotate, faGears, faCalendar, faCircleArrowLeft, faCalendarDays, faArrowRightFromBracket, faUsers, faUserTie, faUserPen, faBasketShopping, faAddressCard, faPersonChalkboard, faEarthEurope, faFileImport, faScrewdriverWrench, faBezierCurve, faCloudSunRain, faFile, faDesktop, faMobileRetro, faRulerCombined, faChalkboardUser, faQuestion, faTreeCity, faPlugCircleBolt, faLightbulb, faSeedling, faFire, faMaskVentilator, faFileInvoiceDollar, faLandmark, faCubesStacked, faPlug, faBuildingColumns, faDiagramNext, faRulerVertical, faSliders, faBorderNone, faGripVertical, faTriangleExclamation, faCheckCircle, faCalendarTimes, faAnglesUp, faBan, faIdCardClip, faCircleInfo, faGreaterThan, faGreaterThanEqual, faLessThan, faLessThanEqual, faEquals, faGauge, faBoltLightning, faSolarPanel, faCarBattery, faChargingStation, faFaucet, faShower, faDroplet, faDropletSlash, faLadderWater, faSterlingSign, faCoins, faWallet, faDollar, faCentSign, faEuroSign, faGlobe, faSpellCheck, faGaugeSimple, faGaugeSimpleHigh, faGaugeMed, faGaugeHigh, faFileCsv, faFilePdf, faEnvelope, faFileExcel, faFileWord, faFileImage, faList, faCloudSun, faWind, faBatteryQuarter, faSmog, faTemperatureQuarter, faA, faSlash, faCircleReg, faExclamationTriangle, faLaptopCode, faFileSignature, faCircleCheckReg, faBurst, faBoxArchive, faEnvelopeOpenText, faEraser, faFileCirclePlus, faRss, faThumbTack, faCloudArrowUp, faArrowUpFromBracket });
	import * as VueGoogleMaps from 'vue2-google-maps';
	import * as VueMenu from '@hscmap/vue-menu';
	import VueMask from 'v-mask';
	import UniqueId from 'vue-unique-id';
	import VueScreen from 'vue-screen';
	/** Composant pour le fullScreen */
  	import VueFullscreen from 'vue-fullscreen'

	//#region Stores Vuex
	import AuthentificationStore from '@/store/AuthentificationStore';
	import OidcStore from '@/store/OidcStore';
	import GlobalStore from "@/store/GlobalStore";
	import SessionStore from '@/store/SessionStore';
	import FilterTreeStore from "@/store/FilterTreeStore";
	import ObjectStore from "@/store/ObjectStore";
	import ObjectDashboardStore from '@/store/ObjectDashboardStore';
	import MainDashboardStore from '@/store/MainDashboardStore';
	import ObjectMoveStore from "@/store/ObjectMoveStore";
	import CartoMod from '@/store/CartoMod';
	import WidgetLibraryStore from '@/store/WidgetLibraryStore';
	import ShareStore from '@/store/ShareStore';
	import DownloadingStore from '@/store/DownloadingStore';
	import MenuStore from '@/store/MenuStore';
	import NotificationsStore from '@/store/NotificationsStore';
	import CertificateStore from '@/store/CertificateStore';
	//import HeritageTreeMod from '@/store/HeritageTreeMod';
	//#endregion Store Vuex

	import { ROOT, DCX_GOOGLE_KEY, MAIN_FILTER_TREE, SESSIONLESS_ROUTES } from '@/App.settings';
	import { ConnectionUtils, LinkUtils } from '@/components/commons/Utils';

	Vue.component('font-awesome-icon', FontAwesomeIcon);
	Vue.component('font-awesome-layers', FontAwesomeLayers)

	Vue.use(Vuex);
	Vue.use(VueRouter);
	Vue.use(PortalVue);
	Vue.use(BootstrapVue);
	Vue.use(IconsPlugin);
	Vue.use(loadingMaskPlugIn);
	Vue.use(axiosDirectPlugIn);
	Vue.use(VueCookies);
	Vue.use(VueMenu);
	Vue.use(VueMask);
	Vue.use(UniqueId);
	Vue.use(VueFullscreen);
	Vue.use(VueScreen, 'bootstrap');
	Vue.use(VueFormWizard);

	/** Fonction globale utilisable pour le formatage de date dans la section template */
	Vue.filter('formatDate', function(value, format: string) {
		if (value && ((value instanceof Date) && !isNaN(value.valueOf()) || typeof value === 'string'))
			return moment(String(value)).format(format);
		else
			return "";
	});


    Vue.use(VueGoogleMaps, {
        load: {
            key: DCX_GOOGLE_KEY,
            libraries: 'places,drawing'
        },
        installComponents: true,
        autobindAllEvents: true
    });

	axios.defaults.headers.common = {
		"Content-Type": "application/json"
	}

	export const router = new VueRouter({ routes, mode: 'history', base: ROOT });

	// Redirige vers la page de Connexion si pas de token
	// prevent navigation without token
	router.beforeEach((to, from, next) => {
		const token = Vue.cookies.get('access_token') || "";

		if (to.path === '/') {
			return next();
		}

		if (self !== undefined && self !== null) {
			if (SESSIONLESS_ROUTES.includes(to.name as string)) {
				if (token === "") {
					next();
				} else {
					next({ path: '/' });
				}
			} else {
				next();
			}
		} else {
			to.path === '/' ? next() : next({ path: '/' });
		}
	});

	export const store = createStore(Vuex.Store, {
		state: {
		},
		modules: {
			AuthentificationStore,
			OidcStore,
			SessionStore,
			GlobalStore,
			/** Instance principale de FilterTree utilisée pour l'arborescence de FullSibar.vue */
			[MAIN_FILTER_TREE]: FilterTreeStore,
			ObjectStore,
			ObjectMoveStore,
            CartoMod,
            ObjectDashboardStore,
			//,HeritageTreeMod
			MainDashboardStore,
			WidgetLibraryStore,
			ShareStore,
			DownloadingStore,
			MenuStore,
			NotificationsStore,
			CertificateStore
		}
    });

	@Component({
		router,
		store,
		components: {
			ConnexionPage,
			SignPage,
			LoadingMask,
			MasterPage,
			SupervisionPage,
			FontAwesomeIcon,
			FontAwesomeLayers
		}
	})
	export default class App extends mixins(LinkUtils, ConnectionUtils) {
		/** Indique si le masque de chargement est affiché ou non */
		@Getter('GetShowLoadingMask')
		private showLoadingMask!: boolean;

		/** Message affiché dans le masque de chargement */
		@Getter('GetLoadingMaskMessage')
		private loadingMaskMessage!: string;
	}
</script>

<style lang="scss">
	/** Thème par défaut de la V3 */
	@import './assets/css/default-theme.scss';
	/** Pour utilisation des icons de Bootstrap non inclus dans la dernière version de Bootstrap-vue */
	@import 'bootstrap-icons/font/bootstrap-icons.css';

	/** Import des changement de styles spécifiques pour le composant vue-multiselect */
	@import './components/commons/Fields/multiSelect.scss';

	@import url(https://fonts.googleapis.com/css2?family=Work+Sans:wght@500&display=swap);

	/** @todo Mettre tout le CSS de App.vue dans default-theme.scss ??!! + formater default-theme.scss */

	//#region Compléments Bootstrap pour mise en forme de boutons
	/** Classe Css à appliquer pour tous les boutons ronds de taille normal sans texte */
	.btn-circle {
		height: 2rem;
		width: 2rem;
		padding: 0 !important;
		border-radius: 50% !important;
	}

	/** Classe Css à appliquer pour tous les boutons ronds de petite taille sans texte */
	.btn-circle-small {
		height: 1.5rem;
		width: 1.5rem;
		padding: 0 !important;
		border-radius: 50rem !important;	/** Equivalent à $border-radius-pill dans default-theme.scss */
	}

	/** Classe utiliser pour le cercle des image du menu des foctionnalités */
	.img-circle {
		height: 2rem;
		width: 2rem;
		border-radius: 50% !important;
	}

	//#endregion Compléments Bootstrap pour mise en forme de boutons

	//#region Css commun composant splitpanes (https://antoniandre.github.io/splitpanes/)
	.splitpanes__pane {
		background-color: transparent !important;
	}
	//#endregion Css commun Vue-Grid-Layout (https://antoniandre.github.io/splitpanes/)

	//#region Css commun Vue-Grid-Layout (https://jbaysolutions.github.io/vue-grid-layout/)
	.container .vue-grid-item.vue-grid-placeholder {
        background: red;
        opacity: 0.2;
        transition-duration: 100ms;
        z-index: 2;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
    }

    .vue-grid-layout {
        background-color: transparent !important;
        transition: none;
    }

    .vue-grid-item:not(.vue-grid-placeholder) {
        background: white;
        border: 1px solid darkgrey;
        border-radius: 3px;
    }

    .vue-grid-item .resizing {
        opacity: 0.9;
    }

    .vue-grid-item .static {
        background: #cce;
    }

    .vue-grid-item .text {
        font-size: 24px;
        text-align: center;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        height: 100%;
        width: 100%;
    }

    .vue-grid-item {
        height: 100%;
        width: 100%;
    }

    .vue-grid-item .minMax {
        font-size: 12px;
    }

    .vue-grid-item .add {
        cursor: pointer;
    }

	.vue-draggable-handle {
		/* position: absolute; */
		/* width: 100%;  */
		/* height: 20px; */
		top: 0;
		left: 0;
		background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
		background-position: bottom right;
		/* padding: 0 8px 8px 0; */
		background-repeat: no-repeat;
		background-origin: content-box;
		/* box-sizing: border-box; */
		cursor: grab;
	}

	.vue-draggable-handle:hover {
			background-color: var(--gray);
		}

    .vue-grid-item {
		/* Désactive les animations du vue-grid-layout au chargement */
        transition: none;
		/** Ombre sur chaque vue-grid-item */
		box-shadow: 0 0.125rem 0.25rem rgba(33, 37, 41, 0.075) !important;
        border-color: var(--gray) !important;
    }

	/** 
		Optimisations pour éviter ralentissements du Vue-Grid-Layout : désactivation de certains éléments du vue-Grid-Layout
		@see https://github.com/jbaysolutions/vue-grid-layout/issues/68
	*/
	.vue-grid-item.cssTransforms {
		transition-property: inherit !important;
	}
  	.vue-resizable.resizing { 
		pointer-events: none;
	}
  	.vue-draggable-dragging { 
		pointer-events: none;
		// transition:none;
		// z-index: 3;
	}
	//#endregion Css commun Vue-Grid-Layout (https://jbaysolutions.github.io/vue-grid-layout/)

	//#region Affichage fenêtre modale en plein écran (b-modal Bootstrap Vue)
	.fullscreen-modal {
		height: 100% !important;
		width: 100% !important;
		max-width: 100% !important;
		/* max-height: var(--fullHeight) !important; */
		margin: 0 !important;
		overflow: hidden !important;
		padding: 1vh !important;
	}
	//#endregion Affichage fenêtre modale en plein écran (b-modal Bootstrap Vue)
</style>
